<script>
  // A single marketing-matched pricing card, shared by the single-tier checkout
  // view and the three-up comparison grid on the Pricing page.
  export let tier;
  export let ctaLabel;
  // Outlines the card in blue: the pre-selected plan in the checkout view, or
  // the badged plan in the comparison grid.
  export let highlight = false;
  // The MOST POPULAR badge only makes sense when there are other cards to
  // compare against, so the single-card checkout view turns it off.
  export let showBadge = true;
  export let showUpgrade = false;
  export let currentType = null;
  export let onSubscribe;
</script>

<div
  class="relative bg-white rounded-2xl w-full max-w-[21.25rem] px-7 py-8 text-left border-2 {highlight
    ? 'border-[#3B7DD8]'
    : 'border-slate-200'} shadow-[0_10px_34px_rgba(19,26,38,0.10)]"
  style="font-family: 'Segoe UI', Arial, sans-serif;">
  {#if showBadge && tier.badge}
    <div
      class="absolute -top-3.5 left-1/2 -translate-x-1/2 bg-[#3B7DD8] text-white text-xs font-bold tracking-wide px-3.5 py-1.5 rounded-full whitespace-nowrap">
      MOST POPULAR
    </div>
  {/if}

  <div class="font-bold text-[1.05rem]">{tier.label}</div>
  <p class="text-[1.25rem] font-extrabold mb-3.5 leading-snug">
    {tier.price}<span class="text-[0.9rem] font-semibold text-[#4a5568]">/month per {tier.unit}</span>
  </p>
  <p class="text-[0.9rem] text-[#4a5568] min-h-[2.625rem] mb-2">{tier.sell}</p>

  <ul class="list-none p-0 m-0 mb-7">
    {#each tier.checks as check (check)}
      <li class="flex items-start gap-2 py-[5px] text-[0.9rem] text-[#444]">
        <span class="font-extrabold text-[#3B7DD8] flex-none">&#10003;</span>
        <span>{check}</span>
      </li>
    {/each}
  </ul>

  {#if showUpgrade && currentType === tier.subscriptionType}
    <button
      class="block text-center border-none py-[0.8125rem] rounded-lg text-[0.95rem] font-bold w-full bg-gray-100 text-gray-400"
      disabled>
      Current Plan
    </button>
  {:else}
    <button
      class="block text-center py-[0.8125rem] rounded-lg text-[0.95rem] font-bold w-full cursor-pointer bg-[#3B7DD8] text-white hover:bg-[#255aa8]"
      on:click={() => onSubscribe(tier.priceId)}>
      {ctaLabel}
    </button>
  {/if}
</div>
